import { gql } from '@apollo/client';
import { useEffect, useMemo, useState } from 'react';
import { MstHinmei } from 'src/common/interfaces';
import { MitsumoriType } from 'src/common/number-enum';
import { getMstHinmei } from 'src/graphql/queries';
import { useAppLazyQuery } from 'src/libs/hooks';

const hinmeiKbEnum = [
  { value: MitsumoriType.SOFTWARE, label: 'ソフトウェア' },
  { value: MitsumoriType.TEMPLATE, label: 'テンプレート' },
  { value: MitsumoriType.LICENSE, label: 'ライセンス' },
  { value: MitsumoriType.USEWARE, label: 'ユースウェア' },
  { value: MitsumoriType.KDSS, label: 'KDSS保守' },
];
const ModalGuideHinmeiForControlRule = ({
  setIsOpen,
  onCallbackFunction,
  hinmeiKb,
}: {
  setIsOpen: (isOpen: boolean) => void;
  onCallbackFunction: (hinmei: MstHinmei) => void;
  hinmeiKb?: number;
}) => {
  const header = ['品名コード', '品名', '品名区分'];

  const [dataMstHinmei, setDataMstHinmei] = useState<Array<MstHinmei>>([]);
  const [mstHinmeiCd, setMstHinmeiCd] = useState<string>('');
  const [mstHinmeiMn, setMstHinmeiMn] = useState<string>('');
  const [mstHinmeiKb, setMstHinmeiKb] = useState<string>(hinmeiKb?.toString() || '');

  const [searchMstHinmei, { data: mstHinmeiData, loading: isMstHinmeiLoading }] = useAppLazyQuery({
    query: gql(getMstHinmei),
  });

  const renderTableHeader = () => {
    return header.map((key, index) => (
      <th
        className="whitespace-nowrap p-[8px] sticky top-0 border-[1px] border-solid border-[#ddd] pt-[12px] pb-[12px] text-center bg-blue-400 text-[#fff]"
        key={index}
      >
        {key.toUpperCase()}
      </th>
    ));
  };

  const renderTableData = useMemo(() => {
    if (dataMstHinmei?.length <= 0 || !dataMstHinmei) return;
    return dataMstHinmei?.map((mstHinmei: MstHinmei, index: number) => {
      return (
        <tr key={index}>
          <td className="p-[8px] border-[1px] border-solid border-[#ddd]">
            <p>{mstHinmei?.mh_hin_cd}</p>
          </td>
          <td className="p-[8px] border-[1px] border-solid border-[#ddd] text-blue-600 cursor-pointer">
            <p onClick={() => onHandleClickHinmei(mstHinmei)}>{mstHinmei?.mh_hin_nm}</p>
          </td>
          <td className="p-[8px] border-[1px] border-solid border-[#ddd]">
            <p>{hinmeiKbEnum[parseInt(mstHinmei?.mh_hin_kb) - 1]?.label}</p>
          </td>
        </tr>
      );
    });
  }, [dataMstHinmei]);

  const onPressSearch = () => {
    const params = {
      mh_hin_cd: mstHinmeiCd === '' ? null : mstHinmeiCd,
      mh_hin_nm: mstHinmeiMn,
      mh_hin_kb: parseInt(mstHinmeiKb) === 0 ? null : parseInt(mstHinmeiKb),
    };

    searchMstHinmei({ variables: { input: params } });
  };

  const onHandleClickHinmei = (mstHinmei: MstHinmei) => {
    onCallbackFunction(mstHinmei);
    setIsOpen(false);
  };

  useEffect(() => {
    const newMstHinmeiData = { ...mstHinmeiData };
    const listMstHinmei: MstHinmei[] =
      newMstHinmeiData?.getMstHinmei
        ?.filter((hinmei: MstHinmei) => {
          return parseInt(hinmei?.mh_hin_cd) > 9;
        })
        ?.sort((hinmei1: any, hinmei2: any) => {
          return hinmei1.mh_hin_cd - hinmei2.mh_hin_cd;
        }) || [];
    setDataMstHinmei(listMstHinmei);
  }, [mstHinmeiData]);

  return (
    <div className="fixed w-full h-full inset-0 flex items-center justify-center">
      <div className="bg-[#00000030] w-full h-full z-[0] inset-0 fixed" />
      <div className="flex fixed bg-white h-4/6 w-1/3 items-center flex-col z-[1] overflow-auto">
        <div className="w-5/6 flex justify-end items-center mt-[10px]">
          <button onClick={() => setIsOpen(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="h-[40px] w-4/5 flex justify-center items-center border border-zinc-300 mt-[50px]">
          <div className="h-full w-2/5 flex justify-center items-center bg-blue-400 text-white">品名コード</div>
          <div className="h-full w-3/5 flex justify-center items-center">
            <input
              className="bg-transparent pl-[5px] h-[40px] w-full pr-[5px] "
              onChange={(event) => {
                if (event.target.value.length > 8) return;
                setMstHinmeiCd(event?.target?.value);
              }}
              type="number"
              name="primary_store_cd"
              value={mstHinmeiCd}
              min={0}
            />
          </div>
        </div>
        <div className="h-[40px] w-4/5 flex justify-center items-center border border-zinc-300 mt-[10px]">
          <div className="h-full w-2/5 flex justify-center items-center bg-blue-400 text-white">品名</div>
          <div className="h-full w-3/5 flex justify-center items-center">
            <input
              className="bg-transparent pl-[5px] h-[40px] w-full"
              onChange={(event) => {
                if (event.target.value.length > 50) return;
                setMstHinmeiMn(event?.target?.value);
              }}
              type="text"
              name="primary_store_nm"
              value={mstHinmeiMn}
            />
          </div>
        </div>
        <div className="h-[40px] w-4/5 flex justify-center items-center border border-zinc-300 mt-[10px]">
          <div className="h-full w-2/5 flex justify-center items-center bg-blue-400 text-white">品名区分</div>
          <div className="h-full w-3/5 flex justify-center items-center">
            <select
              value={mstHinmeiKb}
              name="hinmeiKubun"
              id="mh_hin_kb"
              className="bg-transparent pl-[5px] h-[40px] w-full"
              defaultValue={0}
              onChange={(event) => setMstHinmeiKb(event?.target?.value)}
            >
              <option value={0}></option>
              {hinmeiKbEnum?.map((hinmeiKb, index: number) => {
                return (
                  <option key={index} value={hinmeiKb?.value}>
                    {hinmeiKb?.label}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        <div className="h-[40px] w-4/5	flex justify-end items-center mt-[10px] ">
          <button
            onClick={onPressSearch}
            className="border border-zinc-300 h-[40px] w-[100px] justify-center items-center flex"
          >
            <p>検索</p>
          </button>
        </div>
        <div className="overflow-auto max-h-100 w-4/5 mt-[20px] mb-[20px]">
          <table className="text-center border-collapse border-[3px] border-solid border-[#ddd] w-full td:p-[10px]  ">
            <thead>
              <tr>{renderTableHeader()}</tr>
            </thead>
            <tbody>
              {isMstHinmeiLoading ? (
                <tr>
                  <td
                    colSpan={header.length}
                    className="text-center animate-pulse p-[8px] border-[1px] border-solid border-[#fff]"
                  >
                    Loading...
                  </td>
                </tr>
              ) : (
                renderTableData
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ModalGuideHinmeiForControlRule;
